<template>
    <div>
        <v-dialog :value="dialog" width="500" persistent>
            <v-card class="co-dialog-nova-extincao">
                <v-card-title class="headline text-color-300--text">
                    <div> Extinguir {{ $tc("pt_br.documento").toLowerCase() }}</div>
                    <v-spacer/>
                    <v-icon size="18" @click="$emit('cancelar')"> mdi-window-close </v-icon>
                </v-card-title>

                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                            <v-textarea
                                label="Justificativa"
                                placeholder="Texto"
                                name="Texto"
                                class="required-field"
                                v-model="value.descricao"
                                v-validate="'required'"
                                :error-messages="errors.collect('Texto')"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="background-200" depressed @click="$emit('cancelar')">
                        Cancelar
                    </v-btn>
                    <v-spacer/>
                    <v-btn color="primary" @click="salvar">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <dialog-default-confirmar-acao
            v-if="mostrarConfirmacao"
            :dialog="mostrarConfirmacao"
            sentimento="atencao"
            titulo="Eita! Deixa eu confirmar uma coisa..."
            :subtitulo="mensagemContratito"
            label-botao-principal="EXTINGUIR"
            @acao-principal="confirmar"
            @fechar="fecharConfirmacao"
        />

    </div>
</template>

<script>
import ClmDialog from '@/commons/components/ClmDialog'
import ClmOps from '@/commons/components/ClmOps'
import DialogDefaultConfirmarAcao from '@/commons/components/dialogs/DialogDefaultConfirmarAcao'

export default {
    name: 'DialogNovaExtincao',
    components: {DialogDefaultConfirmarAcao, ClmDialog, ClmOps},
    props: {
        value: {
            type: Object
        },
        dialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mostrarConfirmacao: false
        }
    },
    computed: {
        mensagemContratito() {
            return `Você quer mesmo extinguir o ${this.$tc("pt_br.documento").toLowerCase()} ?`
        },
    },
    methods: {
        abrirModalConfirmacao() {
            this.mostrarConfirmacao = true
        },
        fecharConfirmacao() {
            this.mostrarConfirmacao = false
        },
        confirmar() {
            this.$emit('extinguir')
            this.fecharConfirmacao()
        },
        async salvar() {
            const valido = await this.$validator._base.validateAll()
            if (!valido)return
            
            this.abrirModalConfirmacao()
        },
    }
}
</script>